export default "__VITE_ASSET__DsPxx96G__"